module.exports = __webpack_public_path__ + "static/media/org.14fc4197.svg";